import {RowData} from '@tanstack/table-core';

import {CellTypeDef, TableHelper} from './types';

export function createTableHelper<TData extends RowData>(): TableHelper<TData> {
  return {
    accessorColumn: (accessor, column) => ({...column, accessor}),
    displayColumn: (column) => column,
    cellType: <TValue>(cellTypeDef: CellTypeDef<TData, TValue>) => cellTypeDef,
  };
}
